import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { SettingsMenuBtnModule } from '../settings-menu-btn/settings-menu-btn.module';
import { SearchModule } from '../search/search.module';
import {TranslationSelectorModule, TranslateModule, TranslationSelectorService} from '@xref/ngx';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import {  MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [
    CommonModule,
    SettingsMenuBtnModule,
    SearchModule,
    TranslateModule,
    RouterModule,
    TranslationSelectorModule,
    MatMenuModule,
    MatButtonModule,
    FontAwesomeModule,
    MatFormFieldModule,
    MatSelectModule
  ],
  exports: [HeaderComponent],
  declarations: [HeaderComponent],
  providers: [
    TranslationSelectorService
  ]
})
export class HeaderModule {}
